import { useSelector } from 'react-redux'

import { RootState } from '../../../reducers'
import { lastUpdatedSelector } from '../selectors'

export function useLastUpdatedSelector() {
  return useSelector<RootState, number>(lastUpdatedSelector)
}
